import * as React from 'react';
import i18next from 'i18next';
import LabelHint from "../../_components/LabelHint";
import { Tooltip } from "@material-ui/core";
import CopyContentIcon from "@material-ui/icons/FileCopy";

export default function TicketTypeItemForm(props) {
  return <div className="form__group">
    <div style={{ display: "flex", flexDirection: "row" }}>
      <LabelHint
        title="event_form_title_ticket"
        hint="hint_event_form_title_ticket"
      />
      <div style={{ marginTop: 10, marginLeft: 10 }}>
        ({props.item.name})
      </div>
      <Tooltip title="copy">
        <CopyContentIcon
          onClick={() =>
            navigator.clipboard.writeText(props.item.form)
          }
          width="30"
          height="30"
          color="primary"
          style={{
            marginLeft: 5,
            paddingTop: 5,
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </div>
    <textarea
      id="area1"
      className="form__input"
      placeholder={i18next.t("text")}
      name="wifi"
      readOnly
      value={props.item.form}
    ></textarea>
  </div>;
}
